import { logger } from '../../../../utils/logger';
import { installJsSipUaEventListeners } from '../audiocodes-sip';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type WebRtcService = any;

export function installConnectAudioCodeInterceptor(webRtcService: WebRtcService): void {
  const originalConnectAudioCodeServer = webRtcService.connectAudioCodeServer?.bind(webRtcService);
  if (!originalConnectAudioCodeServer) {
    return;
  }

  webRtcService.connectAudioCodeServer = function (...args: unknown[]) {
    logger.debug('[CXone DEBUG] connectAudioCodeServer() called');
    logger.debug('[CXone DEBUG]   audioCodeIsConnected:', webRtcService.audioCodeIsConnected);
    logger.debug(
      '[CXone DEBUG]   audioCodeConnectRequested:',
      webRtcService.audioCodeConnectRequested
    );

    const ac = webRtcService.audioCode;
    if (ac) {
      logger.debug('[CXone DEBUG]   audioCode object found');
      logger.debug('[CXone DEBUG]   audioCode.serverConfig:', ac.serverConfig);
      logger.debug('[CXone DEBUG]   audioCode.account:', ac.account);

      let watchCount = 0;
      const watchUaInterval = setInterval(() => {
        watchCount++;
        if (ac.jssipUA) {
          logger.debug(`[CXone DEBUG] jssipUA created after ${watchCount * 100}ms`);
          logger.debug('[CXone DEBUG]   jssipUA.isConnected():', ac.jssipUA.isConnected?.());
          logger.debug('[CXone DEBUG]   jssipUA.isRegistered():', ac.jssipUA.isRegistered?.());

          if (ac.jssipUA._registrator) {
            logger.debug(
              '[CXone DEBUG]   _registrator._registered:',
              ac.jssipUA._registrator._registered
            );
            logger.debug(
              '[CXone DEBUG]   _registrator._registering:',
              ac.jssipUA._registrator._registering
            );
          }

          clearInterval(watchUaInterval);

          if (!ac.jssipUA.__uaListenersInstalled) {
            installJsSipUaEventListeners(ac);
          }
        }
        if (watchCount >= 300) {
          logger.warn('[CXone DEBUG] jssipUA never created after 30 seconds');
          clearInterval(watchUaInterval);
        }
      }, 100);
    } else {
      logger.warn('[CXone DEBUG]   audioCode is null/undefined');
    }

    return originalConnectAudioCodeServer(...args);
  };
}
